export const reserveFallbackQueue = {
    items: [
        {
            id: 201,
            slug: 'reserve-demo-201',
            application_name: 'Заявка Резерв-201',
            application_sending: '2026-05-19',
            estimated_date_of_shipment: '2026-05-21',
            date_of_sending: null,
            location: { id: 1, city: 'Тюмень', address: 'Склад Hyosung' },
            related: 'СЦ Тюмень',
            whom: 'Инженерная группа',
            transport: 'ТК',
            address: 'Тюмень',
            ttn: '',
            csm5x: 2,
            csm2x: 1,
            csmTE2x: 0,
        },
        {
            id: 202,
            slug: 'reserve-demo-202',
            application_name: 'Заявка Резерв-202',
            application_sending: '2026-05-18',
            estimated_date_of_shipment: '2026-05-22',
            date_of_sending: null,
            location: { id: 2, city: 'Москва', address: 'Склад МСК' },
            related: 'СЦ Москва',
            whom: 'Склад МСК',
            transport: 'Самовывоз',
            address: 'Москва',
            ttn: 'TTN-202',
            csm5x: 1,
            csm2x: 2,
            csmTE2x: 1,
        },
    ],
};

export const reserveFallbackDetails = {
    'reserve-demo-201': {
        ...reserveFallbackQueue.items[0],
        modules: [
            {
                id: 401,
                serial_number: 'CGO123456',
                party_number: '7430007591',
                system: '5X',
                repair_status: 'Готов',
                movement_status: 'В заявке',
                location: { city: 'Тюмень' },
                engineer: 'Иванов И.И.',
            },
            {
                id: 402,
                serial_number: 'CEBU654321',
                party_number: '7000000253',
                system: 'TE 2X',
                repair_status: 'Готов',
                movement_status: 'В заявке',
                location: { city: 'Тюмень' },
                engineer: 'Петров П.П.',
            },
        ],
        module_counts: {
            total: 2,
            by_system: { '5X': 1, '2X': 0, 'TE 2X': 1 },
        },
    },
    'reserve-demo-202': {
        ...reserveFallbackQueue.items[1],
        modules: [
            {
                id: 403,
                serial_number: 'CH555111',
                party_number: '7430006918',
                system: '2X',
                repair_status: 'Готов',
                movement_status: 'В заявке',
                location: { city: 'Москва' },
                engineer: 'Сидоров С.С.',
            },
        ],
        module_counts: {
            total: 1,
            by_system: { '5X': 0, '2X': 1, 'TE 2X': 0 },
        },
    },
};

export const waitingActsFallbackQueue = {
    items: [
        {
            id: 301,
            slug: 'acts-demo-301',
            application_name: 'Акт Ремонт-301',
            application_sending: '2026-05-16',
            estimated_date_of_shipment: '2026-05-17',
            date_of_sending: '2026-05-17',
            location: { id: 1, city: 'Тюмень', address: 'Склад Hyosung' },
            related: 'СЦ Тюмень',
            whom: 'Тюмень',
            transport: 'ТК',
            address: 'Тюмень',
            ttn: 'ACT-301',
            csm5x: 3,
            csm2x: 1,
            csmTE2x: 0,
            excel_file_url: null,
        },
    ],
};

export const waitingActsFallbackDetails = {
    'acts-demo-301': {
        ...waitingActsFallbackQueue.items[0],
        modules: [
            {
                id: 501,
                serial_number: 'CGG220011',
                party_number: '7430006261',
                system: '5X',
                repair_status: 'Готов',
                movement_status: 'Отгружен',
                location: { city: 'Тюмень' },
                engineer: 'Васильев В.В.',
            },
            {
                id: 502,
                serial_number: 'CH990044',
                party_number: '7430006918',
                system: '2X',
                repair_status: 'Готов',
                movement_status: 'Отгружен',
                location: { city: 'Тюмень' },
                engineer: 'Егоров Е.Е.',
            },
        ],
        module_counts: {
            total: 2,
            by_system: { '5X': 1, '2X': 1, 'TE 2X': 0 },
        },
    },
};

export const waitingShipmentsFallbackQueue = {
    items: [
        {
            id: 401,
            slug: 'shipments-demo-401',
            application_name: 'Отправка Ремонт-401',
            application_sending: '2026-05-18',
            estimated_date_of_shipment: '2026-05-20',
            date_of_sending: null,
            location: { id: 2, city: 'Москва', address: 'Склад МСК' },
            related: 'СЦ Москва',
            whom: 'Склад Москва',
            transport: 'ТК',
            address: 'Москва',
            ttn: '',
            csm5x: 0,
            csm2x: 2,
            csmTE2x: 1,
            excel_file_url: null,
            pdf_file_url: null,
        },
    ],
};

export const waitingShipmentsFallbackDetails = {
    'shipments-demo-401': {
        ...waitingShipmentsFallbackQueue.items[0],
        modules: [
            {
                id: 601,
                serial_number: 'CECC882211',
                party_number: '7000000279',
                system: 'TE 2X',
                repair_status: 'Готов к отгрузке',
                movement_status: 'В заявке',
                location: { city: 'Москва' },
                engineer: 'Макаров М.М.',
            },
            {
                id: 602,
                serial_number: 'CFYZ110055',
                party_number: '7430004176',
                system: '2X',
                repair_status: 'Готов к отгрузке',
                movement_status: 'В заявке',
                location: { city: 'Москва' },
                engineer: 'Смирнов С.С.',
            },
        ],
        module_counts: {
            total: 2,
            by_system: { '5X': 0, '2X': 1, 'TE 2X': 1 },
        },
    },
};
